// eslint-disable-next-line require-jsdoc
import React, { useState } from 'react';
/*
 *import PropTypes from 'prop-types';
 * IDS Components
 */
import Button from '@ids/button';
import { Collapse } from '@material-ui/core';
/*
 * assests
 * Third party
 */

// eslint-disable-next-line  import/prefer-default-export
export const CheckFraud = (props) => {
  /*
   * const { pageData } = props;
   * const product = pageData.Department.BroughtTogether;
   */
  const [showTerms, setShowTerms] = useState(false);
  // var lastDiv;

  const showTermsAndScroll = (flag) => {
    setShowTerms(flag);

    setTimeout(() => {
      props.onTermsClicked(flag);
    }, 250);

    /*
     * if (flag) {
     *     lastDiv.scrollIntoView({ behavior: "smooth" })
     * }
     */
  };

  return (
    <div style={{ overflowY: 'scroll' }}>
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-lg-12">
          <h3 className="check-fraud-header margin-bottom-10">
            Protecting you from check fraud is our number one concern.
          </h3>
          <p className="p2-regular margin-bottom-10">
            That’s why 12 months of{' '}
            <span className="font-wgt-500">CheckLock™ Fraud Protection</span> is now included with
            every check order at no cost to you. This includes:
          </p>
          <ul>
            <li>
              <p className="p2-regular margin-bottom-10">
                Free replacement and expedited delivery<sup>1</sup> of compromised checks and other
                affected supplies like deposit slips and endorsement stamps.
              </p>
            </li>
            <li>
              <p className="p2-regular margin-bottom-10">
                Security precautions from when you place your order through the printing process
                that exceed industry standards.
              </p>
              <ul>
                <li>
                  <p className="p2-regular margin-bottom-10">
                    Your account information is protected and orders are screened for potential
                    fraud.
                  </p>
                </li>
                <li>
                  <p className="p2-regular margin-bottom-10">
                    Stringent background checks and other security measures for our check printing
                    facility.
                  </p>
                </li>
                <li>
                  <p className="p2-regular margin-bottom-10">
                    We ship every order in custom-designed, non-descript, tamper-evident packaging
                    for extra protection.
                  </p>
                </li>
              </ul>
            </li>
          </ul>
          <ul style={{ listStyle: 'none', paddingLeft: '20px' }}>
            <li>
              <p className="p2-regular margin-bottom-10">
                For more information on check fraud, call (866) 570-3842 and ask to speak to one of
                our CheckLock Fraud Resolution Experts.
              </p>
            </li>
            <li>
              <p className="p2-regular margin-bottom-10">
                For details on CheckLock Fraud Protection see terms and conditions. CheckLock Fraud
                Protection applies to pre-printed checks and is not offered, applicable, or
                available to residents of New York or Massachusetts.
              </p>
            </li>
          </ul>
          <div style={{ textAlign: 'center' }}>
            <Button
              id="btn-show-term"
              theme="quickbooks"
              buttonType="tertiary"
              onClick={() => showTermsAndScroll(!showTerms)}
            >
              Terms and conditions
            </Button>
          </div>
          <Collapse in={showTerms}>
            <div className="terms-condition">
              <p className="margin-bottom-10">
                CheckLock Fraud Protection is granted to Intuit customers who purchased preprinted
                checks from Intuit on or after December 10th, 2010 and are authorized to draw funds
                from legitimate bank accounts preprinted on Intuit checks.
              </p>

              <p className="margin-bottom-10">
                CheckLock Fraud Protection applies to pre-printed checks and is not offered,
                applicable or available to residents of the states of New York and Massachusetts.
              </p>

              <p className="margin-bottom-10">
                CheckLock Fraud Protection is provided for a period of 12 months from customer’s
                preprinted check order date.
              </p>

              <p className="margin-bottom-10">
                1. Free replacement and overnight delivery of compromised checks and other affected
                supplies, such as deposit slips and endorsement stamps.
              </p>

              <ul>
                <li>
                  <p className="margin-bottom-10">
                    If your pre-printed checks or financial supplies are lost or stolen your account
                    may be compromised - notify your bank both by phone and in writing. Immediately
                    close your compromised checking account and any connected accounts. Request a
                    Stop Payment on stolen check number(s).
                  </p>
                </li>
                <li>
                  <p className="margin-bottom-10">
                    Call one of our agents, report your case and your new bank account information.
                  </p>
                </li>
                <li>
                  <p className="margin-bottom-10">
                    Our agents will process your order for new checks, deposit slips, and
                    endorsement stamps free of charge and expedite delivery so that you can continue
                    to operate your business with minimal disruption.
                  </p>
                </li>
              </ul>
            </div>
          </Collapse>
        </div>
      </div>
      {/* <div ref={(el) => { lastDiv = el }}></div> */}
    </div>
  );
};

CheckFraud.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  // pageData: PropTypes.object.isRequired,
};
